/**
 * B526 (e4) — schema pieces the OTA management contracts (ota.ts) and the
 * partner-facing OCTO contracts (octo.ts) share. Deliberately NOT a module
 * the registry collects: it holds no operations.
 */
import { z } from "zod";

/** Mirrors @transact/ota's OCTO_UNIT_TYPES (pinned equal by the handlers' test, through the save contracts). */
export const zOctoUnitType = z.enum(["ADULT", "YOUTH", "CHILD", "INFANT", "FAMILY", "SENIOR", "STUDENT", "MILITARY", "OTHER"]);
